<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <div class="page-content">
            <div class="page-content-button">
                <a-button type="primary" class="cus-button" @click="handlePush">我要咨询</a-button>
            </div>
            <div class="page-text page-text-block">
                <div class="li-header">我的咨询</div>
                <div class="li-list" v-if="rtData.listData.length > 0">
                    <div class="li-list-row" v-for="(item, i) in rtData.listData" :key="i">
                        <div class="li-list-row-dodd"></div>
                        <div class="li-list-row-content" @click="handleClick(item.id)">
                            <div style="width: 70%">{{ item.msg }}</div>
                            <div style="width: 30%;">{{ item.createTime.split(' ')[0] }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import { onMounted, reactive} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
import {userConsultationListApi} from "@/api/technology"
import {useRouter} from "vue-router";
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "TechnicalConsulting",
    setup() {
        const router = useRouter()
        const title = reactive({
            cn: '技术咨询',
            en: 'TECHNICAL CONSULTING',
            hasSearch: false,
            titleStyle: false,
            banner,
        })
        const rtData = reactive({
            listData: []
        })
        const userConsultationList = async () => {
            const params = {
                "current": 1,
                "model": {
                },
                "size": 100,
            }
            const data = await userConsultationListApi(params)
            rtData.listData = data.records
        }
        const handlePush = () => {
            router.push({ name: 'TechnicalConsulting'})
        }
        const handleClick = (id) => {
            router.push({ name: 'TechnicalDetail', query: {id: id}})
        }
        onMounted(() => {
            userConsultationList()
        })
        return {
            title,
            rtData,
            handlePush,
            handleClick
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>


<style scoped lang="stylus">
.content {
    .page-content {
        padding 20px 15px
        background-color #FFF
        .page-content-button {
            width 100%
            text-align center
            .cus-button {
                width 199px
                background #03CA8F
                border-radius 6px
                border-color #03CA8F
                margin-bottom 15px
            }
        }
        .page-text-block {
            padding 15px 20px
            box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            border-radius 3px
        }
    }
}
</style>